require('./mortgageRequestExpensesTrading.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const Immutable = require('immutable');
const { FormattedText } = require('core/i18n').i18n;
// @ commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestExpensesItemList = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestExpensesItemList');

// @ constants
const { currencyExpensesParams } = require('constants/mortgageRequestCurrencyFormats');

class MortgageRequestExpensesTrading extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: false,
            id: 'trading'
        };
    }

    render() {
        const { tradingAmmount, totalGastosCompraVenta, isNewProperty } = this.props;

        const taxInformation = isNewProperty
                                ? ['mortgageRequestExpensesTrading-adj', tradingAmmount.get('ajd')]
                                : ['mortgageRequestExpensesTrading-itp', tradingAmmount.get('itp')];

        const expensesTotal = MortgageRequestCurrencyHelp(currencyExpensesParams(totalGastosCompraVenta));
        const rightContentTotal = (
            <div className="mortgage-request-expenses-trading__amount">
                {expensesTotal}
            </div>
        );

        const expensesItemClasses = {
            item: ['mortgage-request-expenses-trading__item', 'row'],
            title: ['col-xs-9'],
            value: ['mortgage-request-expenses-trading__value', 'col-xs-3'],
            list: ['mortgage-request-expenses-trading', 'list-unstyled'],
        };
        const itemList = [
            {
                text: 'mortgageRequestCommons-notary',
                value: tradingAmmount.get('notaria')
            },
            {
                text: taxInformation[0],
                value: taxInformation[1]
            },
            {
                text: 'mortgageRequestCommons-register',
                value: tradingAmmount.get('registro')
            },
            {
                text: 'mortgageRequestCommons-management',
                value: tradingAmmount.get('gestoria')
            },
        ];

        return (
            <Accordion
                customClassName="mortgage-request-expenses-trading"
                isExpanded={this.state.isExpanded}
                id={this.state.id}
            >
                <AccordionHeader name="AccordionHeader" iconStyle isMiddleArrowPosition rightContent={rightContentTotal}>
                    <div className="mortgage-request-expenses-trading__header row no-outside-gutter">
                        <FormattedText value="mortgageRequestCommons-forSaleText"/>
                    </div>
                </AccordionHeader>

                <AccordionBody name="AccordionBody">
                    <MortgageRequestExpensesItemList
                        expensesItemClasses={expensesItemClasses}
                        itemsList={itemList}
                    />
                </AccordionBody>
            </Accordion>
        );
    }
}

MortgageRequestExpensesTrading.propTypes = {
    tradingAmmount: PropTypes.object.isRequired,
    totalGastosCompraVenta: PropTypes.number.isRequired,
    isNewProperty: PropTypes.bool.isRequired
};

MortgageRequestExpensesTrading.defaultProps = {
    tradingAmmount: Immutable.Map(),
    totalGastosCompraVenta: 0
};

module.exports = MortgageRequestExpensesTrading;
